<script>
  // Shared owner-avatar strip for the CardCollection shell (ADR-0010). One copy
  // of the colored-initials stack used by both CardRow and CardTile, killing the
  // duplicated avatar markup the refactor exists to remove (review §4).
  import { ownerColor } from '../../lib/logic/card-owners.js';

  let { owners = [], max = 4, size = 20, overlap = 4, showSingleName = false } = $props();

  const shown = $derived(owners.slice(0, max));
</script>

<div class="owner-avatars" style:--avatar-size="{size}px">
  {#each shown as owner, i (owner)}
    <div
      class="owner-avatar"
      style="background: {ownerColor(owner)}; z-index: {max - i}; margin-left: {i > 0
        ? `-${overlap}px`
        : '0'}"
      title={owner}
    >
      {owner.charAt(0).toUpperCase()}
    </div>
  {/each}
  {#if showSingleName && owners.length === 1}
    <span class="owner-single-name">{owners[0]}</span>
  {/if}
</div>

<style>
  .owner-avatars {
    display: flex;
    align-items: center;
  }
  .owner-avatar {
    width: var(--avatar-size);
    height: var(--avatar-size);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    font-weight: 700;
    color: #fff;
    position: relative;
    border: 1.5px solid var(--color-bg-surface);
    flex-shrink: 0;
  }
  .owner-single-name {
    font-size: 11px;
    color: var(--color-text-tertiary);
    margin-left: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
